module.exports = "<button ng-class=\"{\t'cui-button_state_active': button.isButtonActive(),\t'ng-disabled': button.isButtonDisabled(),\t'cui-button_look_{{button.look}}': button.look,\t'cui-state_hovered': button.isButtonHovered()}\" ng-transclude=\"ng-transclude\" class=\"cui-button\"></button>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/button/template.jade
// module id = 818
// module chunks = 0